export function getDocumentUniqueId(documentKind, docData) {
  if (documentKind === "credit_note") {
    return docData?.credit_note_unique_id;
  }
  return docData?.invoice_unique_id;
}

export function applyDocumentDetailsFromApi(
  documentKind,
  data,
  { setInvoiceData, setShippingAddress, setInvoiceItems, setCompanySettings }
) {
  if (!data) {
    return;
  }
  if (documentKind === "credit_note") {
    setInvoiceData(data.credit_note_data);
    setShippingAddress(data.credit_note_shipping_address);
    setInvoiceItems(data.credit_note_items);
    if (data.company_settings) {
      setCompanySettings(data.company_settings);
    }
    return;
  }
  setInvoiceData(data.invoice_data);
  setShippingAddress(data.invoice_shipping_address);
  setInvoiceItems(data.invoice_items);
  setCompanySettings(data.company_settings);
}
